import withSize from './with-size'
import SizeMe from './component'

withSize.SizeMe = SizeMe
withSize.withSize = withSize

export default withSize
